import { render, staticRenderFns } from "./NestedQuestionRenderer.vue?vue&type=template&id=6d5fadf9&scoped=true"
import script from "./NestedQuestionRenderer.vue?vue&type=script&lang=js"
export * from "./NestedQuestionRenderer.vue?vue&type=script&lang=js"
import style0 from "./NestedQuestionRenderer.vue?vue&type=style&index=0&id=6d5fadf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5fadf9",
  null
  
)

export default component.exports